import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import Communication from './Communication';

/**
 * Contains utilities for managing the stored customer data
 */
class CustStorage {
	static custStorageData = {};

	// call getCustStorage and parse/store its response in the local custStorageData object
	static async init() {
		const response = await Communication.getCustStorage();

		if (Communication.isSuccessful(response)) {
			const { data = {} } = response;
			const storageData = isString(data.storageData)
				? JSON.parse(data.storageData)
				: {};

			this.custStorageData = storageData;
		}
	}

	static getItem(itemName) {
		return this.custStorageData[itemName] || null;
	}

	static async setItem(itemName, data) {
		if (isString(itemName) && isObject(data)) {
			this.custStorageData[itemName] = data;

			const response = await Communication.setCustStorage({
				storageData: JSON.stringify(this.custStorageData),
			});

			return response;
		}
	}
}

export default CustStorage;
